import "./InventorySelector.css";

import { Button } from "../../forms";

interface InventorySelectorProps {
  buttons: string[];
  activeSelector?: string;
  onChange?: (button: string) => void;
}

export const InventorySelector = ({ buttons, activeSelector, onChange }: InventorySelectorProps): JSX.Element => {
  return (
    <div className="ButtonSlider">
      {buttons.map((button) => (
        <Button
          key={button}
          text={button}
          variant={activeSelector === button ? "primary" : "secondary"}
          className={`SliderTabButton ${activeSelector === button ? "active" : ""}`}
          onClick={() => onChange?.(button)}
          corners="rounded"
          size="small"
        />
      ))}
    </div>
  );
};
